export function isString(it: any): it is string {
	if (!it && it !== "") {
		return false;
	}
	return typeof it === "string";
}
